import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import PlayerYoutube from './PlayerYoutube';
import { Youtube } from 'lucide-react';
import imgLogoSG from '../assets/logoSG2.png';

function Videos() {
	const [dataVideoClip, setDataVideoClip] = useState();

	const [linkVideo, setLinkVideo] = useState('');

	const fetchDataVideoClip = (selectYear) => {
		const params = { year: selectYear };
		const headers = {
			'Content-Type': 'application/x-www-form-urlencoded',
		};
		axios
			.post(`${API_BASE_URL}videoclip`, params, { headers })
			.then((response) => {
				setDataVideoClip(response.data);
				setLinkVideo(response.data.items[0].vc_link);
			})
			.catch((err) => {
				console.log('Err', err);
			});
	};
	useEffect(() => {
		fetchDataVideoClip(2025);
	}, []);

	const handleChangeVideo = (link) => {
		setLinkVideo(link);
	};

	return (
		<div
			id='videos'
			className='lg:mt-10 mt-5 lg:px-48 text-white lg:text-3xl text-3xl w-full scroll-mt-[100px]'
		>
			<div className='flex items-center gap-2'>
				<span>
					<img src={imgLogoSG} alt='' width={32} />
				</span>
				<h2>VIDEO CLIP</h2>
			</div>
			<div className='lg:flex mt-10 gap-5'>
				{/* Player youtube bên trái */}
				<div className='lg:w-1/2'>
					<PlayerYoutube linkPlay={linkVideo} />
				</div>

				{/* List video bên phải */}
				<div className='mt-5 lg:mt-0 px-4 lg:w-1/2 lg:flex flex-wrap gap-3 overflow-y-auto h-[460px] rounded-md'>
					{dataVideoClip &&
						dataVideoClip.items.map((itemVC) => (
							<div
								className='lg:w-[calc(50%-12px)] rounded-md flex flex-col'
								key={itemVC.vc_id}
							>
								<div
									className='cursor-pointer overflow-hidden rounded-t-md relative'
									onClick={() =>
										handleChangeVideo(itemVC.vc_link)
									}
								>
									<img
										alt={itemVC.vc_tieude}
										src={itemVC.vc_hinhanh}
										className='opacity-60 hover:opacity-90'
									/>
									<div className='absolute top-[calc(50%-20px)] left-[calc(50%-20px)]'>
										<Youtube size={40} color='#CBD5E1' />
									</div>
								</div>
								<div className='text-sm px-3 bg-slate-900 w-full py-2 rounded-b-md min-h-[56px]'>
									{itemVC.vc_tieude.substring(0, 70) + '...'}
								</div>
							</div>
						))}
				</div>
			</div>
		</div>
	);
}

export default Videos;
